export const SET_LATEST_FOREX = "SET_LATEST_FOREX";